import { useMutation, useQuery } from "@tanstack/react-query";
import { labTestsApiService } from "modules/Volunteer/AssigningStudyModule/StudyTestList/api/studyScreeningTests";
import { LabTestsParams } from "../helper/studytest.types";

interface ApiResponse<T = any> {
    data: T;
    message: string;
    statusCode: number;
}

// ------------------------------------------------------------------
//-- LAB TESTS SERVICE
// ------------------------------------------------------------------

export const useLabTestsService = ({
    searchText,
    pageNumber = 1,
    pageSize = 10,
    studyid,
    volunteerid,
    enabled = false,
}: LabTestsParams & { enabled?: boolean } = {}) => {
    const SelectAllQuery = useQuery({
        queryKey: [
            "lab-tests-selectAll",
            searchText,
            pageNumber,
            pageSize,
            studyid,
            volunteerid,
        ],
        queryFn: () =>
            labTestsApiService.getSelectAllData({
                studyid,
                volunteerid,
                searchText,
                pageNumber,
                pageSize,
            }),
        enabled: enabled,
    });

    const InsertMutation = useMutation<ApiResponse, Error, any>({
        mutationFn: (payload: any) => labTestsApiService.insertData(payload),
    });

    const UpdateMutation = useMutation<ApiResponse, Error, any>({
        mutationFn: (payload: any) => labTestsApiService.updateData(payload),
    });

    const DeleteMutation = useMutation<
        ApiResponse,
        Error,
        {
            studyid: number | null;
            volunteerid: number | null;
            studylabtestid: number | null;
            updatereason: string
        }
    >({
        mutationFn: (payload) =>
            labTestsApiService.deleteData({
                studyid: payload.studyid,
                volunteerid: payload.volunteerid,
                studylabtestid: payload.studylabtestid,
                updatereason: payload.updatereason,
            }),
    });

    const VerifyLabTestMutation = useMutation<
        ApiResponse,
        Error,
        {
            verifypin: string;
            studylabtestid: number;
            studyid: number;
            volunteerid: number;
            verifystatus: string;
            verifiedby: number;
        }
    >({
        mutationFn: (payload) => labTestsApiService.verifyLabTest(payload),
    });

    return {
        SelectAllQuery,
        InsertMutation,
        UpdateMutation,
        DeleteMutation,
        VerifyLabTestMutation,
    };
};
